
import { mapGetters, mapMutations } from 'vuex';
import Arrow45 from '~/components/svg/Arrow45';
import VueTypes from 'vue-types';
import MyPreloader from '~/components/ui/MyPreloader';
import EcomMenuBadges from '~/components/badges/EcomMenuBadges.vue';

export default {
    data() {
        return {
            activeMenuItem: null,
            isLoad: true,
            isSafari: false,
            hoverTimeout: null,
        };
    },
    props: {
        isItemLink: VueTypes.bool.def(true),
        isHoverUsed: VueTypes.bool.def(true),
    },
    watch: {
        '$i18n.locale': '$fetch',
    },
    components: { EcomMenuBadges, Arrow45, MyPreloader },
    computed: {
        ...mapGetters(['getMenu']),
        ...mapGetters({
            globalSettings: 'global/globalSettings',
        }),
    },
    methods: {
        ...mapMutations(['setMainMenu']),

        // Оптимизированная функция для установки активного элемента с дебаунсом
        setActiveMenuItem(id) {
            if (this.activeMenuItem !== id) {
                this.activeMenuItem = id;
            }
        },

        // Дебаунс для mouseenter события
        handleMouseEnter(id) {
            if (!this.isHoverUsed) return;

            if (this.hoverTimeout) {
                clearTimeout(this.hoverTimeout);
            }

            this.hoverTimeout = setTimeout(() => {
                this.setActiveMenuItem(id);
            }, 50); // 50ms задержка для предотвращения избыточных срабатываний
        },

        // Оптимизированная функция клика
        handleCategoryClick(id) {
            if (!this.isItemLink) {
                this.setActiveMenuItem(id);
            }
        },

        // Условное отображение подкатегорий для предотвращения рендера всех элементов
        shouldShowSubcategories(menuItemId) {
            return this.activeMenuItem === menuItemId;
        },

        checkSafari() {
            const userAgent = navigator.userAgent;
            const isSafari = /^((?!chrome|android).)*safari/i.test(userAgent) && !/CriOS/i.test(userAgent);
            this.isSafari = isSafari;
        },
    },

    mounted() {
        this.checkSafari();
    },

    beforeDestroy() {
        // Очистка таймера при уничтожении компонента
        if (this.hoverTimeout) {
            clearTimeout(this.hoverTimeout);
        }
    },

    async fetch() {
        let menu = await this.$axios.$get('general/menu_tree');
        if (menu.length) {
            // Заморозка объекта для предотвращения реактивности на глубоких уровнях
            const frozenMenu = Object.freeze(
                menu.map(item => ({
                    ...item,
                    subcategories: item.subcategories
                        ? Object.freeze(
                              item.subcategories.map(sub => ({
                                  ...sub,
                                  subcategories: sub.subcategories ? Object.freeze(sub.subcategories) : sub.subcategories,
                              }))
                          )
                        : item.subcategories,
                }))
            );

            this.setMainMenu(frozenMenu);
            this.setActiveMenuItem(menu[0].id);
        }
        this.isLoad = false;
    },

    fetchOnServer: true,
    fetchKey: 'site-menu',
};
